import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=51d7eb8a&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=51d7eb8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7eb8a",
  null
  
)

export default component.exports